<div class="view">
  <div class="head">
    <app-breadcrumb [constructor_name]="constructor.name"></app-breadcrumb>
  </div>
  <div class="body">
    <div [style.margin]="'0px 0px -6.5px 0px'">
      <img
        src="https://clubperladelpacificogye.com/wp-content/uploads/2020/01/PAGINA.jpg"
        style="object-fit: contain; background-size: cover"
        width="100%"
      />
    </div>
  </div>
</div>
